export const COLOR_PICKER_WIDGET_NAMESPACE = 'widget.color-picker'
